export const SharePercentFromColumn = [
  {
    accessor: 'from',
    Header: 'از ',
    key: 'from',
    header: 'از ',
  },
  {
    accessor: 'to',
    Header: 'تا ',
    key: 'to',
    header: 'تا ',
  },
  {
    accessor: 'percentage',
    Header: 'درصد',
    key: 'percentage',
    header: 'درصد',
  },

  {
    Header: 'عملیات',
    accessor: 'operation',
    key: '',
    header: '',
  },
]
export const SharePercentFromColumn2 = [

  {
    accessor: 'to',
    Header: 'مقدار',
    key: 'to',
    header: 'مقدار',
  },
  {
    accessor: 'percentage',
    Header: 'درصد',
    key: 'percentage',
    header: 'درصد',
  },

  {
    Header: 'عملیات',
    accessor: 'operation',
    key: '',
    header: '',
  },
]
